import { useMemo } from "react"
import { X } from "lucide-react"

import { buildPublicQuoteDoc } from "../../utils/quotes/public-quote"
import PublicQuoteWrapper from "./public-quote"

import "./quote-preview.scss"

/**
 * Agent-side "client preview" overlay. Takes a quote-like object - the live
 * builder state, or a saved draft / sent quote doc - builds the exact sanitised
 * public projection the published page would read (buildPublicQuoteDoc), and
 * renders the real public quote page from it in preview mode.
 *
 * Nothing is written to the database and nothing is bookable: this is a
 * display-only look at what the client would see, used both from the New Quote
 * builder and from the enquiry's quote cards. The public page reads the sales
 * agent's name / photo live from their user doc, so the preview shows the real
 * agent card.
 */
export default function QuotePreviewModal({ quote, enquiryID, onClose }) {
	const projection = useMemo(
		() =>
			buildPublicQuoteDoc({
				quote: quote || {},
				token: quote?.public_token || "preview",
				enquiryID: enquiryID || quote?.enquiry || "",
				quoteID: quote?.id || "preview",
			}),
		[quote, enquiryID],
	)

	return (
		<div className="quote-preview-overlay">
			<div className="quote-preview-frame" role="dialog" aria-modal="true" aria-label="Client preview">
				<div className="quote-preview-bar">
					<h3 className="quote-preview-bar-title">Quote Preview</h3>
					<button type="button" className="quote-preview-close" onClick={onClose} aria-label="Close preview">
						<X size={18} />
					</button>
				</div>

				<div className="quote-preview-scroll">
					<PublicQuoteWrapper previewQuote={projection} isPreview />
				</div>
			</div>
		</div>
	)
}
